"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyConverter = void 0;

var _CurrencyConverter = _interopRequireDefault(require("./components/CurrencyConverter"));

var _MultiCurrencyConverter = _interopRequireDefault(require("./components/MultiCurrencyConverter"));

var _currencyConverter = require("./store/currencyConverter/currencyConverter.reducer");

var _currencyConverter2 = require("./store/currencyConverter/currencyConverter.epics");

var actions = _interopRequireWildcard(require("./store/currencyConverter/currencyConverter.actions"));

var selectors = _interopRequireWildcard(require("./store/currencyConverter/currencyConverter.selectors"));

var CurrencyConverter = {
  Component: _CurrencyConverter.default,
  ComponentMulti: _MultiCurrencyConverter.default,
  reducer: _currencyConverter.currencyConverter,
  epics: _currencyConverter2.currencyConverterEpics,
  actions,
  selectors
};
exports.CurrencyConverter = CurrencyConverter;